import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const solutions = ['Identificar el patrón inconsciente que sabotea tus relaciones', 'Interrumpir la voz interna que te mantiene en bucle de inseguridad', 'Instalar una nueva identidad que atrae amor sano y comprometido', 'Sentirte segura, valiosa y en paz contigo misma', 'Dejar de necesitar validación externa para sentirte completa'];
export function SolutionSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-beige-50 text-center" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-137">
          <div className="text-4xl mb-4" data-id="element-138">✨</div>
          <img src="https://cdn.magicpatterns.com/uploads/eUs5WaNA8AXguc6HSQJrGL/Captura_de_pantalla_2026-04-28_a_la(s)_9.34.20_p._m..png" alt="Paty" className="w-40 h-40 rounded-full object-cover mx-auto mb-6 shadow-lg" data-id="element-139" />
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-8" data-id="element-140">
            En solo 3 DÍAS vas a:
          </h2>

          <div className="space-y-4 text-left max-w-2xl mx-auto" data-id="element-141">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center space-x-4 bg-white p-4 rounded-lg shadow-sm" data-id="element-142">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-143" />
                <p className="text-gray-800 font-medium" data-id="element-144">{solution}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}